import React, { Component } from "react";
import { Button } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import logo from "assets/img/front-logo.png";
import "assets/css/login.css";
import { twofaService } from "_services/twofa.service";

class PhoneConfirmation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: "",
    };
  }

  handleContinue = async () => {
    this.setState({ loading: true, error: "" });

    try {
      const data = await twofaService.sendOtp(this.props.preAuthToken);

      if (data.status === "OTP_SENT") {
        this.props.onOtpSent();
      } else if (data.status === "SESSION_EXPIRED") {
        this.props.onSessionExpired();
      } else {
        this.setState({ error: data.message || "Failed to send OTP" });
      }
    } catch (err) {
      this.setState({
        error: err.message || "Unable to send OTP. Please try again.",
      });
    }

    this.setState({ loading: false });
  };

  render() {
    return (
      <div className="login-outer-cover">
        <div className="login-cover gray-bg-color">
          <div className="logo-content loginLogoMain">
            <div className="loginLogoInner">
              <img src={logo} alt="logo" />
            </div>
          </div>
          <div className="login-inner-cover">
            <div className="login-content">
              <div className="Login">
                <h3 style={{ marginBottom: "10px", textAlign: "center" }}>
                  Verify Your Phone Number
                </h3>
                <p style={{ marginBottom: "5px", textAlign: "center", color: "#666" }}>
                  We have a phone number on file for your account:
                </p>
                <p style={{ marginBottom: "20px", textAlign: "center", fontSize: "18px", fontWeight: "bold" }}>
                  {this.props.maskedPhone}
                </p>

                {this.state.error && (
                  <p style={{ color: "red", fontSize: "13px", marginBottom: "10px", textAlign: "center" }}>
                    {this.state.error}
                  </p>
                )}

                <div className="action-btns" style={{ marginBottom: "10px" }}>
                  <Button
                    color="primary"
                    className={this.state.loading ? "buttonSuccess btn1" : "btn1"}
                    disabled={this.state.loading}
                    onClick={this.handleContinue}
                  >
                    Continue with this number
                    {this.state.loading && (
                      <CircularProgress size={24} className="buttonProgress" />
                    )}
                  </Button>
                </div>

                <div style={{ textAlign: "center" }}>
                  <a
                    href="#"
                    onClick={(e) => { e.preventDefault(); this.props.onChangePhone(); }}
                    style={{ color: "#1976d2", fontSize: "15px", fontWeight: "600" }}
                  >
                    Use a different phone number
                  </a>
                </div>

                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <a
                    href="#"
                    onClick={(e) => { e.preventDefault(); this.props.onBackToLogin(); }}
                    style={{ color: "#1976d2", fontSize: "14px" }}
                  >
                    Back to Login
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PhoneConfirmation;
